import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import type { SparkJoinedFavouriteResponse } from 'types/Spark/SparkFavourite';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import {
  generateFilter,
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { useCurrentUser } from 'hooks/common/useCurrentUser';
import { generateJoinedFavouriteSparks } from 'helpers/favourite';

const getSparkFavourites = (userID: string) => {
  const queryArray = [
    generateFilter('userID', userID),
    generateIncludeQuery([
      'favouriteList',
      'spark.sparkCategories',
      'spark.marketplaceAccount',
      'spark.sparkImages',
      'spark.sparkRatings',
      'spark.sparkFavourites',
    ]),
  ];
  const url = generateURL(SPARK_RESOURCE_TYPES.SPARK_FAVOURITES, queryArray);
  return fetchWrapper<SparkJoinedFavouriteResponse>({
    url: url,
    method: 'GET',
  });
};

export function useSparkFavourites() {
  const { currentUserID } = useCurrentUser();
  const response = useQuery(
    'sparkFavourites',
    () => getSparkFavourites(currentUserID || ''),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Spark Favourites: ${error.message}`);
        }
      },
      ...CACHE_AND_STALE_TIME,
    }
  );
  const sparksGroupedByFavouriteID = generateJoinedFavouriteSparks(
    response.data
  );
  return {
    ...response,
    sparksGroupedByFavouriteID,
  };
}
